import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import './MorePage.css';

export const BooksPage: React.FC = () => {
  const { colors } = useTheme();

  const books = [
    { icon: '📕', title: 'Mukhtasar al-Akhdarī', path: '/books/akhdari', desc: 'Fiqh of worship' },
    { icon: '📗', title: 'Matn al-ʿAshmāwiyyah', path: '/books/ashmawiyyah', desc: 'Fiqh of worship' },
  ];

  return (
    <div className="more-page" style={{ backgroundColor: colors.background, color: colors.text }}>
      <h2>📚 Books</h2>
      <div className="features-grid">
        {books.map((book) => (
          <Link
            key={book.path}
            to={book.path}
            className="feature-card"
            style={{ backgroundColor: colors.cardBackground, borderColor: colors.border }}
          >
            <div className="feature-icon">{book.icon}</div>
            <div className="feature-title" style={{ color: colors.text }}>{book.title}</div>
            <div className="feature-desc" style={{ color: colors.muted }}>{book.desc}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};
